import React, { useEffect, useState } from 'react'

import '../../App.css'
import Menu from '../../components/UI/UIMenu'
import Modal from '../../components/UI/UIModal'
import UISwitch from '../../components/UI/UISwitch'
import UIButton from '../../components/UI/UIButton'
// import Pagination from '../../components/UI/Pagination'
import UITextInput from '../../components/UI/UITextInput'
import { Icon } from '../../components/Icon'
import { ResourcesHeader, ResourcesTableData } from '../../data/index'

import { toast } from 'react-toastify'
import { useQuery } from 'react-query'
import Loading from '../../components/UI/Loading'
import { getCategoriesData } from './apiCalls'
import {
  createCategory,
  deleteCategory,
  updateCategory,
} from '../../api/admin/resources'
import {
  resourceCategoryFormData,
  resourcesCategoriesResponse,
} from '../../utils/types'
// import { calculatePageCount } from '../policy/utils'

interface CategoriesProps {
  setIsView: React.Dispatch<React.SetStateAction<string>>
  setId: React.Dispatch<React.SetStateAction<string>>
  setSId: React.Dispatch<React.SetStateAction<string>>
  breadcrumbArray: {
    id: string;
    name: string;
  }[] 
  setBreadcrumbArray: React.Dispatch<React.SetStateAction<{
    id: string;
    name: string;
  }[]>>
}

const initialData = {
  name: '',
  candidateAccess: false,
  resources: [],
}

interface ResourcesHeaderInterface {
  'Category Name': string
  'Candidate Access': string
  Categories: string
  Resources: string
}

const Categories: React.FC<CategoriesProps> = ({
  setIsView,
  setId,
  setSId,
  setBreadcrumbArray
}) => {
  const [formData, setFormData] =
    useState<resourceCategoryFormData>(initialData)
  const [ID, setID] = useState('')
  const [isOpenCreateModal, setIsOpenCreateModal] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [isOpenDelete, setIsOpenDelete] = useState(false)

  const [isOpenMenu, setIsOpenMenu] = useState<boolean[]>(
    new Array(ResourcesTableData?.length || 0).fill(false)
  )
  // const [currentPage, setCurrentPage] = useState<number>(1)
  const [sortOrder, setSortOrder] = useState<{
    [key: string]: 'asc' | 'desc'
  }>({})
  const [sortBy, setSortBy] = useState<string>('name')
  const [sortOrderValue, setSortOrderValue] = useState<string>('asc')

  const categoriesData = useQuery('categories', () =>
    getCategoriesData(
      // currentPage,
      sortBy,
      sortOrderValue
    )
  )

  const handleSort = (key: string) => {
    const newSortOrder = { ...sortOrder }
    if (newSortOrder[key] === 'asc' || newSortOrder[key] === undefined) {
      newSortOrder[key] = 'desc'
      setSortBy(key)
      setSortOrderValue('desc')
    } else {
      newSortOrder[key] = 'asc'
      setSortBy(key)
      setSortOrderValue('asc')
    }
    setSortOrder(newSortOrder)
  }

  useEffect(() => {
    categoriesData.refetch() // Refetch Categories when sortBy or sortOrderValue changes
  }, [sortBy, sortOrderValue])

  // const handlePageChange = (pageNumber: number): void => {
  //   setCurrentPage(pageNumber)
  //   // You can add additional logic here, like fetching data for the new page
  // }

  const handleToggleMenu = (rowIndex: number | null) => {
    const updatedMenuState = isOpenMenu.map((isOpen: unknown, index: number) =>
      index === rowIndex ? !isOpen : false
    )
    setIsOpenMenu(updatedMenuState)
  }

  const createNewCategory = async (): Promise<void> => {
    const response = (await createCategory(formData)) as {
      status?: string
      data: resourcesCategoriesResponse
    }
    if (response?.status == 'successful') {
      categoriesData.refetch()
      setIsEdit(false)
      setFormData(initialData)
      setIsOpenCreateModal(false)
      toast.success('Category Created.', {
        position: 'top-right',
      })
    } else {
      toast.error('Network Error.', {
        position: 'top-right',
      })
    }
  }

  const editResourceCategory = async (): Promise<void> => {
    const response = (await updateCategory(formData, ID)) as {
      status?: string
      data: resourcesCategoriesResponse
    }
    if (response?.status == 'successful') {
      categoriesData.refetch()
      // setIsOpen(!isOpen)
      setIsEdit(false)
      setFormData(initialData)
      setIsOpenCreateModal(false)
      toast.success('Category Updated.', {
        position: 'top-right',
      })
    } else {
      toast.error('Network Error.', {
        position: 'top-right',
      })
    }
  }

  const statusBgColor = (status: boolean): string => {
    switch (status) {
      case true:
        return 'lightGreen'
      case false:
        return 'paleYellow'
      default:
        return 'gray3'
    }
  }
  const handleChange = (fieldName: string, value: string | boolean): void => {
    setFormData((prevState) => ({
      ...prevState,
      [fieldName]: value,
    }))
  }
  const removeCategory = async (): Promise<void> => {
    try {
      const response = (await deleteCategory({ id: ID })) as {
        status?: string
        data: resourcesCategoriesResponse
      }
      if (response?.status == 'successful') {
        categoriesData.refetch()
        setIsEdit(false)
        setIsOpenDelete(false)
        setIsOpenDelete(!isOpenDelete)
      } else {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    } catch (error) {
      toast.error('An error occurred while deleting partner.', {
        position: 'top-right',
      })
    }
  }

  return (
    <>
      <div
        className={
          'flex flex-col gap-20 w-full bg-white  h-full rounded-3xl p-8 '
        }
      >
        <div className="flex flex-col gap-10 w-full relative h-full">
          <div className={'flex w-full justify-between items-start '}>
            <div className="flex-col w-[50%] gap-[20px]">
              <p className={'text-[18px] text-text2 font-bold '}>Resources</p>
              {/* <p
                className={
                  'text-[14px] font-normal text-text1 leading-[24px] mt-2'
                }
              >
                Please add your resource categories here. You can also specify
                the types of access to the candidate.
              </p> */}
            </div>

            <div className={'flex flex-row gap-[15px]'}>
              <div
                onClick={() => {
                  setIsOpenCreateModal(!isOpenCreateModal)
                  setIsEdit(false)
                }}
                className="gap-[10px]  bg-bluishGreen items-center justify-between min-w-[95px] text-white h-12 px-[20px] flex rounded-[72px]   cursor-pointer "
              >
                <p className={'font-medium text-[14px] text-white'}>
                  Create Category
                </p>
                <Icon
                  name={'IconPlus'}
                  strokeWidth={1}
                  stroke={'white'}
                  width={16}
                  height={16}
                />
              </div>
            </div>
          </div>

          {/* content container */}
          {/* table component */}
          {categoriesData?.isLoading && (
            <div className="flex justify-center items-center h-screen">
              <Loading size="large" />
            </div>
          )}
          {!categoriesData?.isLoading && (
            <>
              <table className="min-w-full table-auto divide-y divide-white  ">
                <thead className="sticky top-0 z-10 mb-4  ">
                  <tr className="bg-gray2 rounded-lg h-10 mb-18">
                    {ResourcesHeader?.map((item, index: number) => {
                      return (
                        <th
                          key={index}
                          className={`w-1/8 px-4 py-3 text-left ${index === 0 ? 'rounded-l-lg' : ''} ${index === ResourcesHeader?.length - 1 ? 'rounded-r-lg' : ''} ${ResourcesHeader?.length - 1 === index ? 'border-none ' : 'border-r  border-white'}`}
                        >
                          <div className="flex items-center">
                            <p className="text-text1 font-semibold text-sm flex-1">
                              {item.replace(/_/g, ' ')}
                            </p>
                            <div
                              className="cursor-pointer"
                              onClick={() => {
                                let sortBy = ''
                                switch (
                                  item as keyof ResourcesHeaderInterface
                                ) {
                                  case 'Category Name':
                                    sortBy = 'name'
                                    break
                                  case 'Candidate Access':
                                    sortBy = 'candidateAccess'
                                    break
                                  case 'Categories':
                                    sortBy = 'sub_categories'
                                    break
                                  case 'Resources':
                                    sortBy = 'resources'
                                    break
                                  default:
                                    break
                                }
                                handleSort(sortBy)
                              }}
                            >
                              <Icon
                                name={'IconChevronDown'}
                                width={16}
                                height={16}
                                strokeWidth={1}
                                stroke={'#67A5B9'}
                              />
                            </div>
                          </div>
                        </th>
                      )
                    })}
                    {/* <th className="w-1/8 px-4 py-3 border text-left border-white"></th> */}
                  </tr>
                </thead>
                <tbody>
                  {categoriesData?.data?.data?.map((item, index) => (
                    <>
                      <tr className="bg-gray1">
                        {/* Example row */}
                        <td
                          onClick={() => {
                            setIsView('subCategories')
                            setId(item.id)
                            setSId(item.schoolId)
                            setBreadcrumbArray(prev => [...prev, {
                              id: item.id,
                              name: item.name
                            }])

                          }}
                          className="px-4 text-text1 font-medium text-[12px] h-[48px] py-2 border border-white"
                        >
                          {item.name}
                        </td>
                        <td className="px-4 text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                          <div
                            className={`rounded-[40px] w-[40px] flex justify-center items-center h-[28px] bg-${statusBgColor(item.candidateAccess)}`}
                          >
                            <p className="text-xs text-text2 font-medium">
                              {item.candidateAccess == true ? 'Yes' : 'No'}
                            </p>
                          </div>
                        </td>
                        <td className="px-4  h-[48px] py-2 border border-white">
                          <div className="flex">
                            <p className="text-text1 font-medium text-[12px] flex-1">
                              {item.sub_categories}
                            </p>
                          </div>
                        </td>

                        <td className="px-4 text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                          <div className="flex">
                            <p className="px-4 text-text1 font-medium text-[12px] flex-1">
                              {item.resources}
                            </p>
                            <div className="mr-4 cursor-pointer">
                              <Menu
                                isOpen={isOpenMenu[index]}
                                items={[
                                  {
                                    label: 'View',
                                    onClick: () => {
                                      setIsView('subCategories')
                                      setId(item.id)
                                      setID(item.id)
                                      setSId(item.schoolId)
                                      handleToggleMenu(index)
                                    },
                                    icon: 'IconEye',
                                    iconColor: '',
                                  },
                                  {
                                    label: 'Edit',
                                    onClick: () => {
                                      setIsEdit(true)
                                      if (item) {
                                        const {
                                          // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                          createdAt,
                                          // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                          parentId,
                                          // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                          id,
                                          // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                          sub_categories,
                                          // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                          updatedAt,
                                          // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                          schoolId,

                                          ...formData
                                        } = item
                                        setId(item?.id)

                                        setFormData({
                                          ...formData,
                                          resources: [],
                                        })
                                      }
                                      setIsOpenCreateModal(!isOpenCreateModal)

                                      setId(item.id)
                                      setID(item.id)
                                      setSId(item.schoolId)
                                    },
                                    icon: 'IconEdit',
                                    iconColor: '',
                                  },
                                  {
                                    label: 'Remove',
                                    onClick: () => {
                                      setIsOpenDelete(!isOpenDelete)
                                      setID(item.id)
                                      setSId(item.schoolId)
                                    },

                                    icon: 'IconTrash',
                                    iconColor: '#FF6666',
                                    textColor: 'text-textError',
                                  },
                                ]}
                                type={'table'}
                                setIsOpenMenu={setIsOpenMenu}
                                isOpenMenus={isOpenMenu}
                              >
                                <div
                                  onClick={() => {
                                    handleToggleMenu(index)
                                  }}
                                >
                                  <Icon
                                    name={'IconDotsVertical'}
                                    width={16}
                                    height={16}
                                    strokeWidth={1.5}
                                    stroke={'#02698C'}
                                  />
                                </div>
                              </Menu>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </>
                  ))}
                </tbody>
              </table>
            </>
          )}

          {/* <div className="absolute bottom-2">

            <Pagination
              currentPage={currentPage}
              totalPages={calculatePageCount(
                Number(categoriesData?.data?.count) || 0
              )}
              onPageChange={handlePageChange}
            />
          </div> */}
        </div>
      </div>
      {/* Create Category Modal */}
      <Modal
        customStyle={{ borderRadius: 16, padding: '16px 6px' }}
        isOpen={isOpenCreateModal}
        onClose={() => setIsOpenCreateModal(!isOpenCreateModal)}
      >
        <div
          className={
            'w-[480px] max-h-[80vh] overflow-scroll custom-scrollbar items-center  p-4 flex flex-col gap-4'
          }
        >
          <div
            onClick={() => setIsOpenCreateModal(!isOpenCreateModal)}
            className="flex w-[100%] justify-end cursor-pointer"
          >
            <Icon name={'IconCross'} stroke="#02698C" height={16} width={16} />
          </div>
          <div className="flex items-center w-[100%] justify-center">
            <Icon
              name={'IconTool'}
              stroke={'#02698C'}
              strokeWidth={0.5}
              height={56}
              width={56}
            />
          </div>
          <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
            <h1 className={'text-text2 text-[18px] font-bold'}>
              {isEdit == true ? 'Edit Category' : 'Create Category'}
            </h1>
            <p className={'text-[14px] text-text1 font-normal'}>
              Please specify the name and access of this category
            </p>
          </div>

          <div className="w-[416px] flex-col flex gap-8 mt-6">
            <div>
              <UITextInput
                label={'Category Name*'}
                value={formData.name}
                onChange={(e) => {
                  handleChange('name', e.target.value)
                }}
                placeholder="Please enter your category name"
                iconName={''}
              />
            </div>
            <div className="w-full p-4 bg-gray1 rounded-xl flex">
              <div className="flex-1">
                <p className="text-sm font-semibold leading-6 text-text4">
                  Staff Access
                </p>
                <p className="text-sm font-normal leading-6 text-text3">
                  Can access files in this category?
                </p>
              </div>
              <div>
                <UISwitch
                  value={formData.candidateAccess}
                  onValueChange={(e: boolean) => {
                    handleChange('candidateAccess', e)
                  }}
                />
              </div>
            </div>
            {isEdit == false && (
              <UIButton
                onClick={() => {
                  createNewCategory()
                }}
                type="submit"
                label="Create"
              />
            )}
            {isEdit == true && (
              <UIButton
                onClick={() => {
                  editResourceCategory()
                }}
                type="submit"
                label="Update"
              />
            )}
          </div>
        </div>
      </Modal>

      {/* Delete Category Modal */}
      <Modal
        customStyle={{ borderRadius: 16, padding: '16px 20px' }}
        isOpen={isOpenDelete}
        onClose={() => setIsOpenDelete(!isOpenDelete)}
      >
        <div
          className={
            'w-[480px] max-h-[80vh] overflow-scroll custom-scrollbar items-center p-4 flex flex-col gap-4'
          }
        >
          <div
            onClick={() => setIsOpenDelete(!isOpenDelete)}
            className="flex w-[100%] justify-end cursor-pointer"
          >
            <Icon name={'IconCross'} stroke="#02698C" height={16} width={16} />
          </div>
          <div className="flex items-center w-[100%] justify-center">
            <Icon
              name={'IconAlertTriangle'}
              stroke={'#FF6666'}
              strokeWidth={1}
              height={52}
              width={52}
            />
          </div>
          <div className="flex flex-col gap-2 items-center w-[100%] justify-center mb-4">
            <h1 className={'text-text2 text-[18px] font-bold'}>
              Delete Category
            </h1>
            <p className={'text-[14px] text-text1 font-normal'}>
              Are you sure you want to delete this category?
            </p>
          </div>
          <div className="w-full flex flex-col gap-4">
            <button
              onClick={() => {
                removeCategory()
              }}
              className="text-textError border-textError border-[1px] min-h-[48px] font-medium rounded-[72px] text-[14px]"
            >
              Yes, I’m sure
            </button>
            <button
              onClick={() => setIsOpenDelete(!isOpenDelete)}
              className="text-text3 border-textError bg-gray2 min-h-[48px] font-medium rounded-[72px] text-[14px]"
            >
              Cancel
            </button>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default Categories
